// extracted by mini-css-extract-plugin
module.exports = {"siteName":"AccommodationRequest_siteName__21qzu"};